module.exports = __webpack_public_path__ + "static/media/signature.14aaa467.png";